import { useEffect, useState } from 'react';
import { axiosClient } from '@/services/axiosClient';

/**
 * <img>, <audio>, <video> and <iframe> cannot send the Bearer token, so the media is fetched with
 * the authenticated axios client and shown from an object URL, revoked on unmount.
 * `url` undefined = nothing to fetch (media not stored yet).
 */
export const useAuthenticatedObjectUrl = (url: string | undefined) => {
  const [objectUrl, setObjectUrl] = useState<string>();
  const [error, setError] = useState(false);

  useEffect(() => {
    // every url change (including to undefined) starts clean: the previous object URL is revoked below
    setObjectUrl(undefined);
    setError(false);
    if (!url) {
      return undefined;
    }
    let cancelled = false;
    let created: string | undefined;
    axiosClient
      .get(url, { responseType: 'blob', timeout: 60_000 })
      .then((response) => {
        if (cancelled) return;
        created = URL.createObjectURL(response.data as Blob);
        setObjectUrl(created);
      })
      .catch(() => {
        if (!cancelled) setError(true);
      });
    return () => {
      cancelled = true;
      if (created) URL.revokeObjectURL(created);
    };
  }, [url]);

  return { objectUrl, error };
};
